import { EffectsCommandMap } from 'dva';
import { ConnectState } from '@/models/connect';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';
import { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
import {
  addExhibitPolicy,
  updateExhibitPolicyStatus,
  updateExhibitOnlineStatus,
  fetchAndSortPolicies,
} from '@/models/shared/exhibitHelpers';
import type {
  ChangeAction,
  AddAPolicyAction,
  UpdateAPolicyAction,
} from './types';

export const policyEffects = {
  *addAPolicy(
    { payload }: AddAPolicyAction,
    { call, select, put }: EffectsCommandMap,
  ) {
    const { collectionExhibitInfoPage }: ConnectState = yield select(
      ({ collectionExhibitInfoPage }: ConnectState) => ({
        collectionExhibitInfoPage,
      }),
    );

    const success: boolean = yield call(addExhibitPolicy, collectionExhibitInfoPage.exhibit_ID, payload.title, payload.text);
    if (!success) return;

    fSetHotspotTooltipVisible('exhibitDetailPage.onlineSwitch', {
      value: true,
      effectiveImmediately: true,
      onlyNullish: true,
    });

    setTimeout(() => {
      fSetHotspotTooltipVisible('exhibitDetailPage.onlineSwitch', {
        value: false,
        effectiveImmediately: false,
        onlyNullish: false,
      });
    });

    if (
      !collectionExhibitInfoPage.exhibit_Online &&
      !collectionExhibitInfoPage.exhibit_ResourceInfo?.type.includes('主题')
    ) {
      const online: boolean = yield call(fPromiseModalConfirm, {
        title: '展品待上架',
        description: '将展品上架开放授权，为你带来更多收益',
        okText: '立即上架',
        cancelText: '暂不上架',
      });

      if (online) {
        yield call(updateExhibitOnlineStatus, collectionExhibitInfoPage.exhibit_ID, 1);
        fSetHotspotTooltipVisible('exhibitDetailPage.onlineSwitch', {
          value: false,
          effectiveImmediately: true,
          onlyNullish: false,
        });
      }
    }

    const { policies, onlineStatus }: { policies: any[]; onlineStatus: number } = yield call(fetchAndSortPolicies, collectionExhibitInfoPage.exhibit_ID);

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        policy_List: policies,
        exhibit_Online: onlineStatus === 1,
      },
    });
  },
  *updateAPolicy(
    { payload }: UpdateAPolicyAction,
    { call, select, put }: EffectsCommandMap,
  ) {
    const { collectionExhibitInfoPage }: ConnectState = yield select(
      ({ collectionExhibitInfoPage }: ConnectState) => ({
        collectionExhibitInfoPage,
      }),
    );
    yield call(updateExhibitPolicyStatus, collectionExhibitInfoPage.exhibit_ID, payload.id, payload.status);

    const { policies }: { policies: any[] } = yield call(fetchAndSortPolicies, collectionExhibitInfoPage.exhibit_ID);

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        policy_List: policies,
      },
    });
  },
};
